<ng-container *transloco="let t">

  <!--sidebar-->
  <c-sidebar
  #sidebar="cSidebar"
  class="d-print-none sidebar sidebar-fixed"
  id="sidebar"
  visible

  *ngIf="okService.view.show_main_menu"
>
  <c-sidebar-brand
    [brandFull]="{
      src: 'assets/images/ok-alone-logo-reverse.png',
      width: 184,
      height: 59,
      alt: 'OK Alone Logo'
    }"
    [brandNarrow]="{
      src: 'assets/images/logo-icon-dark.png',
      width: 46,
      height: 46,
      alt: 'OK Alone Logo'
    }"
    routerLink="./home"
  >
  </c-sidebar-brand>
    <ng-scrollbar pointerEventsMethod="scrollbar">
  <!--  [ngScrollbar]="ngScrollbarConfig"-->

  <!-- <ul class="sidebar-nav">
    <li class="nav-item">
      <a class="nav-link" routerLink="/home">
        <i class="fa-solid fa-house fa-lg"></i> <span class="title">{{ t('Home') }}</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/mgmt/workers/workers">
        <i class="fa-solid fa-people-group fa-lg"></i> {{ t('Workers') }}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/mgmt/monitors/monitors">
        <i class="fa-solid fa-shield-halved fa-lg"></i> {{ t('Monitors') }}
      </a>
    </li>
  </ul> -->
      <c-sidebar-nav
      [navItems]="navItems"
      >
      </c-sidebar-nav>
    </ng-scrollbar>

</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
  <!--app-header-->
  <app-default-header class="mb-1 d-print-none header header-sticky" position="sticky" sidebarId="sidebar" [class.widget-menu]="!okService.view.show_main_menu"></app-default-header>
  <!--app-body-->
  <div class="body flex-grow-1">
    <div class="container-fluid">

      <div role="alert" *ngIf="okService.alert.message" [className]="'alert  alert-dismissible fade show alert-' + okService.alert.type">
        {{okService.alert.message}}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.clearAlert()"></button>
      </div>



      <div role="alert" *ngIf="okService.billing && okService.billing.trial_active && okService.me.account && this.okService.billing.trial_days > 5" class="alert alert-warning alert-dismissible fade show text-center">
        {{ t('You are currently on a Free Trial which expires on ') }}{{okService.billing.trial_end}} &nbsp;

        <button type="button" class="btn btn-success text-white"  routerLink="/account"><i class="fa-solid fa-check"></i> {{ t('Sign up Now') }}</button>
        &nbsp;
        <button type="button" class="btn btn-warning text-white" *ngIf="okService.billing.extend_allow" (click)="extend()">
          <span *ngIf="!loading"><i class="fa-solid fa-arrows-rotate"></i></span>
          <span *ngIf="loading"><i class="fa-solid fa-spinner fa-spin"></i></span>
          {{ t('Extend Trial') }}
        </button>

        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>



      <router-outlet></router-outlet>
    </div>
  </div>
  <!--app footer-->
  <app-default-footer></app-default-footer>
</div>

</ng-container>
